import { destroyCookie, parseCookies, setCookie } from "nookies";
import { isServer } from "./next";
import info from '@/info.json';

/**
 * Nomes dos cookie para area ADMIN do frontend
 */
export const tokensAdmin = {
  access : `${info.nome_curto}.admin.access-token`,
  refresh : `${info.nome_curto}.admin.refresh-token`
}

/**
 * Nomes dos cookie para area PORTAL do frontend
 */
export const tokensPortal = {
  access: `${info.nome_curto}.access-token`,
  refresh: `${info.nome_curto}.refresh-token`  
}

export const tokensPublico = {
  validAcces: `${info.nome_curto}.public-valid-access`,
}


/**
 * Grava no navegador cookie para expirar 10anos
 * @param key Nome do cookie
 * @param value token
 */
export const setTokenCookie = (key:string, value: string, maxAge: number = 60*60*24*365*10) => {
  setCookie(undefined, key, value, {
    maxAge, // 10 anos  - nunca expirar
    path: '/'
  });
}
/**
 * Retorna valor gravado no token mesmo lado cliente ou servidor
 * @param key Nome do cookie
 * @returns valor gravado no cookie
 */
export const getTokenCookie = (key:string) => {
  const cookies = parseCookies(null);

  if(isServer()){
    const { cookies } = require("next/headers");
    const cookieStore = cookies();

    return cookieStore.get(key)?.value;
  }
  
  return cookies[key] || null;
}

/**
 * Deleta cookie 
 * @param ctx 
 */
export const deleteTokenCookie = (keyCookie: string,ctx?: any) => {
  destroyCookie(ctx, keyCookie, { path: '/' });
}